<template>
  <div
    id="app"
    :dir="isRtl ? 'rtl' : 'ltr'"
    :class="isRtl ? 'rtl' : 'ltr'"
    ref="container"
  >
    <router-view v-if="isReady"></router-view>
    <div v-else-if="isNotInIframe">
    </div>
    <div v-else>
      <Loading class="h-[244px]" />
    </div>
  </div>
</template>

<script>
import Loading from "@/components/partials/Loading";
export default {
  name: "App",
  data() {
    return {
      canRender: false,
      isRtl: false,
      summaryReady: false,
      currentRoute: "",
      lastNotifiedHeight: null,
    };
  },
  components: {
    Loading,
  },
  mounted() {
    let that = this;
    let resizeTimeout;
    const resizeObserver = new ResizeObserver(() => {
      // Debounce resize notifications to prevent excessive calls
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.iframeHeightNotify();
      }, 100);
    });
    resizeObserver.observe(this.$refs.container);

    // Watch for changes to $route and set isCompleteRoute
    this.$watch(
      "$route",
      function (newVal, oldVal) {
        const isCompleteRoute = newVal.name === "complete";
        if (isCompleteRoute && !that.$appState.isTwilightReady) {
          const hasToken = !!that.$salla.storage.get("token");
          const hasStoreIdentifier =
            !!that.$salla.storage.get("Store-Identifier");

          let headers = that.$salla.api.getHeaders();
          if (process.env.VUE_APP_CF_CLIENT) {
            headers["Cf-Access-Client-Id"] = process.env.VUE_APP_CF_CLIENT;
            headers["Cf-Access-Client-Secret"] = process.env.VUE_APP_CF_SECRET;
          }

          if (hasToken && hasStoreIdentifier) {
            headers = {
              ...headers,
              "Store-Identifier": this.$salla.storage.get("Store-Identifier"),
              // 's-user-id': salla.storage.get('user.id'),
              Authorization: "Bearer " + salla.storage.get("token"),
            };

            setTimeout(async () => {
              try {
                const response = await fetch(`${window.mini.apiUrl}/store/settings`, { headers });
                const data = await response.json();
                const settings = data.data;
                window.salla.init(settings);
                that.$appState.isOrderCompleted = true;
                that.$appState.isTwilightReady = true;
                window.parent.postMessage(
                  {
                    source: "checkout",
                    message: that.$salla.config.get("theme.is_rtl", true),
                    type: "direction",
                  },
                  "*"
                );
              } catch (error) {
                console.error(error);
              }
            }, 100); // Increase timeout to reduce rapid firing
          }
        }
      },
      { immediate: true }
    );

    if (this.$appState.isTwilightReady || this.$appState.isOrderCompleted) {
      this.isRtl = this.$salla.config.get("theme.is_rtl", true);
      if (this.isRtl) {
        document.dir = "rtl";
      } else {
        document.dir = "ltr";
      }
    }
  },
  computed: {
    isReady() {
      return (
        (this.$appState.isTwilightReady && this.$appState.isSummaryFetched) ||
        this.$appState.isOrderCompleted ||
        this.$appState.hasError
      );
    },
    isCompleteRoute() {
      return this.$route.name === "complete";
    },
    isNotInIframe() {
      return window.self === window.top;
    }
  },
  watch: {
    isReady: {
      handler(val) {
        if (val) {
          this.isRtl = this.$salla.config.get("theme.is_rtl", true);
        }
      },
      immediate: true,
    },
  },
  methods: {
    iframeHeightNotify() {
      // Only notify if we have a valid container reference and height has changed
      if (!this.$refs?.container) return;
      
      const currentHeight = this.$refs.container.scrollHeight;
      if (this.lastNotifiedHeight === currentHeight) return;
      
      this.lastNotifiedHeight = currentHeight;
      var msg = {
        height: currentHeight,
      };
      window.parent.postMessage(
        { source: "checkout", message: msg, type: "height" },
        "*"
      );
    },
  },
};
</script>
